import modalTemplate from './subscription-modal.jade';
import './subscription-modal.less';
import _ from 'lodash';

// показываем поп-ап на первой странице результатов поиска через 15 секунд после первого скролла на странице
// (для нас это критерий того, что выдача интересна пользователю);
//
// показываем поп-ап при переходе на страницу, отличную от первой в пагинаторе,
// если переход произошёл ранее чем через 15 секунд
// (аналогично, раз пошёл на вторую страницу, значит выдача интересна);
//
// никогда не показываем поп-ап пользователям,
// которые уже имеют подписки (раз у них есть подписки, то они знают как подписываться, им не нужно навязывать);
//
// никогда не показываем поп-ап на выдачах с более чем 1000 объявлений
// (слишком широкая выдача, и такая подписка будет "спамить" пользователя);
//
// никогда не показываем поп-ап на выдачах с нулевым результатом;
//
// если пользователь закрыл поп-ап, то не показываем поп-ап второй раз на этой же странице (при обновлении страницы);
//
// показываем поп-ап не более одного раза за 24 часа (чтобы не было слишком назойливо).
//
// не показываем попап два раза на одной выдаче, включая другие страницы этой выдачи.

const MAX_QUERIES_IN_LOCAL_STORAGE = 30;
const MAX_OFFERS_COUNT = 1000;
const DELAY_AFTER_FIRST_SCROLL_ON_PAGE = 15 * 1000;
const TIMEOUT_BEFORE_NAVIGATION_TO_DIFFERENT_PAGE = 15 * 1000;
const DELAY_BETWEEN_POPUP_SHOWINGS = 24 * 60 * 60 * 1000;
const SUBSCRIPTION_POPUP_HIDDEN_TILL_KEY = 'cian-subscription-popup-hidden-till';
const SUBSCRIPTION_POPUP_HIDDEN_FOR_QUERIES_KEY = 'cian-subscription-popup-hidden-for-queries';

const nowTs = () => new Date().getTime();
const omitPageProp = obj => _.omit(obj, 'page');
const omitPageAndSortProps = obj => _.omit(obj, 'page', 'sort', 'quality');
const isPopupAlreadyShownForQuery = query => {
  const queriesAsString = localStorage.getItem(SUBSCRIPTION_POPUP_HIDDEN_FOR_QUERIES_KEY);
  if (!queriesAsString) {
    return false;
  }
  const queryWithoutPageProp = omitPageAndSortProps(query);
  return _.some(JSON.parse(queriesAsString), q => _.isEqual(q, queryWithoutPageProp));
};

export default angular.module('cian.newbuild.filter.subscriptionModal',
  ['ui.cian.modal'])
  .directive('subscriptionModal', [
    '$rootScope',
    '$uibModal',
    ($rootScope, $uibModal) => ({
      restrict: 'EA',
      scope: {
        lastQuery: '=',
        offersCount: '=',
        email: '=',
        dealType: '=',
        searchTitle: '=',
        url: '='
      },
      link: scope => {
        const showPopup = () => {
          // В следующий раз попап будет показан не ранее чем через delayBetweenPopupShowing миллисекунд
          localStorage.setItem(SUBSCRIPTION_POPUP_HIDDEN_TILL_KEY, String(nowTs() + DELAY_BETWEEN_POPUP_SHOWINGS));

          // Сохраняем текущий запрос без учёта параметра page и больше никогда не показываем попап для такого запроса
          const queriesAsString = localStorage.getItem(SUBSCRIPTION_POPUP_HIDDEN_FOR_QUERIES_KEY);
          const queries = queriesAsString ? JSON.parse(queriesAsString) : [];
          // Ограничиваем количество запросов хранимых в localStorage
          if (queries.length > MAX_QUERIES_IN_LOCAL_STORAGE) {
            queries.shift();
          }
          queries.push(omitPageAndSortProps(scope.lastQuery));
          localStorage.setItem(SUBSCRIPTION_POPUP_HIDDEN_FOR_QUERIES_KEY, JSON.stringify(queries));

          ca('event', {
            name: 'oldevent',
            category: 'subscription',
            action: 'Open',
            label: 'From_cat_popup_Resale'
          });

          $uibModal.open({
            scope: scope,
            template: modalTemplate,
            animation: true,
            windowClass: 'serp-modal serp-subscription-modal',
          });
        };

        let scrollTimeout;
        const onScroll = () => {
          scrollTimeout = setTimeout(() => {
            showPopup();
          }, DELAY_AFTER_FIRST_SCROLL_ON_PAGE);
          unsubscribeFromScrollEvent();
        };

        const unsubscribeFromScrollEvent = () => window.removeEventListener('scroll', onScroll);

        const dispose = () => {
          scrollTimeout && clearTimeout(scrollTimeout);
          unsubscribeFromScrollEvent();
        };


        let searchResultsLoadedTs;
        let elapsedMsBetweenLoadingResultsAndNewSearch;
        // Вотчер срабатывает при старте нового поиска
        scope.$watch(() => $rootScope.offersLoading, newValue => {
          if (newValue) {
            elapsedMsBetweenLoadingResultsAndNewSearch = nowTs() - searchResultsLoadedTs;
            dispose();
          }
        });

        scope.$watch(() => scope.lastQuery, (newValue, oldValue) => {
          searchResultsLoadedTs = nowTs();
          if (scope.offersCount > 0 && scope.offersCount <= MAX_OFFERS_COUNT) {
            const subscriptionPopupHiddenTill = localStorage.getItem(SUBSCRIPTION_POPUP_HIDDEN_TILL_KEY);
            if (!subscriptionPopupHiddenTill || nowTs() > Number(subscriptionPopupHiddenTill)) {
              if (!isPopupAlreadyShownForQuery(newValue)) {
                const watcherCalledFirstTime = newValue === oldValue;
                // Если поменялась только страница
                const onlyPagePropChanged = _.isEqual(omitPageProp(newValue), omitPageProp(oldValue));
                if (!watcherCalledFirstTime && onlyPagePropChanged &&
                    elapsedMsBetweenLoadingResultsAndNewSearch <= TIMEOUT_BEFORE_NAVIGATION_TO_DIFFERENT_PAGE) {
                  showPopup();
                } else {
                  window.addEventListener('scroll', onScroll);
                }
              }
            }
          }
        });

        scope.$on('$destroy', () => dispose);
      }
    })])
  .name;



// WEBPACK FOOTER //
// ./src/serp/directives/subscription-modal/subscription-modal.dir.js